import React from 'react';
import Cookies from 'js-cookie';
import { useSelector, useDispatch } from 'react-redux';
import { FailureLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setInitialCartState } from '@yme/common/redux/cart/actions';
import { COOKIE_CART_ID_KEY } from '@yme/common/redux/cart/constants';
import { getRootPath } from '@yme/components/CheckoutForm/PaymentSteps/selectors';
import { getDealersToolsLabels } from '@yme/components/CheckoutForm/redux/selectors';
import { setIsModalHide } from '@yme/modals/actions';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { IconWrapper } from './styled';
export function GenerateQrErrorModal() {
    const labels = useSelector(getDealersToolsLabels);
    const isRightToLeft = useSelector(getRTL);
    const languageRootPath = useSelector(getRootPath);
    const dispatch = useDispatch();
    const handleSubmitModal = () => {
        Cookies.remove(COOKIE_CART_ID_KEY, {
            path: `${languageRootPath}/`,
        });
        dispatch(setInitialCartState());
        dispatch(setIsModalHide());
    };
    return (React.createElement(StaticModalWindow, { minHeight: "auto", staticModalSize: MD_MODAL, title: labels.checkout_dealersToolsShareViaQRPopUp_header, isRightToLeft: isRightToLeft, footerComponent: React.createElement(ModalWindowFooter, { isSubmitButton: true, submitButtonLabel: labels.checkout_dealersToolResetSession_button, onSubmit: handleSubmitModal }) },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, null,
                React.createElement(SVGIcon, { type: FailureLarge, size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, labels.checkout_dealersToolsShareCartQrCodeError_message)));
}
